/* import __COLOCATED_TEMPLATE__ from './bolt.hbs.js'; */
var _dec, _dec2, _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import SvgIcon from '@square/glass-ui/components/svg/svg-icon';
import { computed } from '@ember/object';

/**
###Params
@param {boolean} banner - Whether or not this bolt icon is present in a banner.
                          This affects the icon sizing.

 */
let Bolt = (_dec = computed('banner'), _dec2 = computed('banner'), _class = class Bolt extends SvgIcon {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "banner", false);
    _defineProperty(this, "viewBox", '0 0 18 24');
    _defineProperty(this, "fill", 'none');
    _defineProperty(this, "defaultColor", '#8716D9');
  }
  get width() {
    return this.banner ? 18 : 12;
  }
  get height() {
    return this.banner ? 24 : 22;
  }
}, _applyDecoratedDescriptor(_class.prototype, "width", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "width"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "height", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "height"), _class.prototype), _class);
export { Bolt as default };